import * as EasyAsync from 'redux-easy-async';
import { MY_NW_NEXT_ASYNC_MIDDLEWARE_TYPE } from '../constants';

export const createAsyncMiddleware = (requestOptions: any) => {
  if (!requestOptions.IdentitySDK) {
    throw new Error('IdentitySDK is required');
  }
  if (!requestOptions.identityApp) {
    throw new Error('identityApp is required');
  }

  return EasyAsync.createAsyncMiddleware({
    namespace: MY_NW_NEXT_ASYNC_MIDDLEWARE_TYPE,
    requestOptions,
  });
};
